import { GeoJsonLayer } from "@deck.gl/layers";
import { Deck, MapView } from "@deck.gl/core";
import boundary from "@/assets/boundary";

export default {
    DATA_HOST: 'https://emu.oniricdev.com',
    AIR_PORTS: "https://d2ad6b4ur7yvpq.cloudfront.net/naturalearth-3.3.0/ne_10m_airports.geojson",
    ICON_MAPPING: {
        marker: { x: 0, y: 0, width: 128, height: 128, mask: false }
    },
    ALL_FILL_COLOR: [254, 160, 0, 200],
    ALL_HALOS_COLOR: [255, 140, 0, 0],
    TARGET_FILL_COLOR: [253,	166,	141, 255],
    TARGET_HALOS_COLOR: [0, 140, 255, 0],

    INITIAL_VIEW_STATE: {
        latitude: 34.0796576964814,
        longitude: -118.373019907142,
        zoom: 9,
        bearing: 0,
        pitch: 0
    },
    VIEW_STATE_2: {
        latitude: 34.0796576964814,
        longitude: -118.373019907142,
        zoom: 12,
        bearing: -30,
        pitch: 10
    },
    VIEW_TILT_SM: {
        latitude: 34.0796576964814,
        longitude: -118.373019907142,
        zoom: 14,
        bearing: 225,
        pitch: 80
    },
    toRadians(degrees) {
        return degrees * Math.PI / 180;
    },
    getDeck(layers, map, click, initialViewState) {
      let deck = new Deck({
          canvas: "deck-canvas",
          width: "calc(80vw - 40px)",
          height: "100%",
          views: new MapView({id: 'minimap'}),
          //[new FirstPersonView({id: 'first-person', controller: false}),new MapView({id: 'minimap'})],
          // initialViewState: INITIAL_VIEW_STATE,
          viewState: initialViewState,
          controller: { dragPan: false, scrollZoom: false, doubleClickZoom: false, touchZoon: false },
          onViewStateChange: ({ viewState }) => {
            // console.log(viewState)
            map.jumpTo({
              center: [viewState.longitude, viewState.latitude],
              zoom: viewState.zoom,
              bearing: viewState.bearing,
              pitch: viewState.pitch,
              around: [viewState.longitude, viewState.latitude]
            });
            
            deck.setProps({viewState: viewState});
          },
          onClick: click,
          layers: layers
        });
      return deck;
    },
    getBoundaryLayer() {
        return new GeoJsonLayer({
          id: "boundary-geojson",
          data: boundary,
          pickable: false,
          stroked: true,
          filled: true,
          lineWidthScale: 20,
          lineWidthMinPixels: 2,
          getFillColor: [255, 140, 0, 150],
          getLineColor: [255, 140, 0, 255],
          transitions: {
            getFillColor: {
              duration: 1000,
              enter: value => {
                return [value[0], value[1], value[2], 0];
              }
            }
          }
        });
    }
}

/*
function getBuildingHalosLayer(color) {
  return new ScatterplotLayer({
    id: "gym-centers-layer",
    data: gym_points.points,
    pickable: false,
    opacity: 0.8,
    stroked: false,
    filled: true,
    radiusScale: 6,
    radiusMinPixels: 1,
    radiusMaxPixels: 100,
    lineWidthMinPixels: 1,
    getRadius: 50,
    getFillColor: color,
    getLineColor: [0, 0, 0],
    transitions: {
      getFillColor: {
        duration: 5000,
        enter: value => {
          return [value[0], value[1], value[2], 255];
        }
      }
    }
  })
}
*/